export var Editions = {
  FREE: 'free',
  STANDARD: 'standard',
  PREMIUM: 'premium',
  ESSENTIALS: 'essentials',
  ENTERPRISE: 'enterprise'
};

// Edition extension options included for legacy reasons. Do not include in new extensions

// Edition extension options included for legacy reasons. Do not include in new extensions

export var Behaviours = {
  LAND: 'land',
  CLOSE: 'close'
};
export var TargetTabs = {
  SAME: 'same',
  NEW: 'new'
};
export var Prompts = {
  NEXT: 'next',
  CLOSE: 'close',
  GO_TO_PRODUCT: 'go-to-product',
  RETURN_TO_PRODUCT: 'return-to-product'
};